/* global google */
var _ = require('underscore');
var GMapsLayerView = require('./gmaps-layer-view');

var GMapsPlainLayerView = function (layerModel, gmapsMap) {
  this.color = layerModel.get('color');
  GMapsLayerView.call(this, layerModel, gmapsMap);
};

_.extend(
  GMapsPlainLayerView.prototype,
  GMapsLayerView.prototype, {

    _update: function () {
      this.color = this.model.get('color');
      this.refreshView();
    },

    getTile: function (coord, zoom, ownerDocument) {
      var div = document.createElement('div');
      div.style.width = this.tileSize.x;
      div.style.height = this.tileSize.y;
      div['background-color'] = this.color;
      return div;
    },

    tileSize: new google.maps.Size(256, 256),
    maxZoom: 100,
    minZoom: 0,
    name: 'plain layer',
    alt: 'plain layer'
  });

module.exports = GMapsPlainLayerView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/gmaps/gmaps-plain-layer-view.js
// module id = 1637
// module chunks = 6